// Courtney's opening line, as the agent's template sends it (greeting_text in
// src/greeting.py): "Hey! I'm Courtney. What can I help you find today?", with
// the caller's first name after "Hey" when it is known. The timeline pins this
// message to the top of the thread; change the wording in both places, or the
// greeting goes back to sorting by arrival time (tests/test_greeting.py checks
// the two still agree).
const GREETING = /^Hey(?: [^!]{1,60})?! I['’]m Courtney\. What can I help you find today\?$/;

export function isCourtneyGreeting(text: string): boolean {
  return GREETING.test(text.trim());
}

/**
 * Courtney's opening line, built exactly like greeting_text() in
 * src/greeting.py. The widget shows it the moment a fresh chat opens, so the
 * visitor never waits on the agent joining (about 1–3 s); her own identical
 * greeting replaces it in place when it arrives.
 */
export function greetingText(firstName?: string | null): string {
  const name = (firstName ?? "").trim();
  return name
    ? `Hey ${name}! I'm Courtney. What can I help you find today?`
    : "Hey! I'm Courtney. What can I help you find today?";
}

/**
 * Whether to show the local greeting: only on a chat that opened fresh (not
 * from a tapped/typed first message, which the agent answers itself, and not a
 * native voice start, where she speaks it), and only until she has said
 * anything herself.
 */
export function shouldShowLocalGreeting({
  openedWithMessage,
  openedWithCall,
  conversationEnded,
  agentHasSpoken,
}: {
  openedWithMessage: boolean;
  openedWithCall: boolean;
  conversationEnded: boolean;
  agentHasSpoken: boolean;
}): boolean {
  return !openedWithMessage && !openedWithCall && !conversationEnded && !agentHasSpoken;
}
